import { getObjectUtil } from 'packages/src'

/**
 * Gets the validation object of a instance.
 * @param  {Instance} instance
 * @returns {Object|null}
 */
function getValidationReduxUtil (instance) {
  return getObjectUtil(instance, 'validation')
}

export {
  getValidationReduxUtil
}
